import {Component, Inject, OnInit, EventEmitter} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {ActiveQuotesClass} from "../../../pages/active-quote/activequotes-class.model";
import {ActiveQuotesService} from "../../../services/active-quotes.service";
import {FacilityDetails} from "../active-quote-dialog/active-quote-details.model";
import {MatSnackBar} from "@angular/material/snack-bar";


@Component({
  selector: 'app-active-terms-dialog',
  templateUrl: './active-terms-dialog.component.html',
  styleUrls: ['./active-terms-dialog.component.scss']
})
export class ActiveTermsDialogComponent implements OnInit {
  termForm: FormGroup;
  onClose = new EventEmitter();
  quoteData: ActiveQuotesClass;
  constructor(@Inject(MAT_DIALOG_DATA) private data, private httpService: HttpClient, public dialog: MatDialog, public form: FormBuilder, private quoteService: ActiveQuotesService, private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    let {brokerMargin, startDate, termsLabel} = this.data;
    brokerMargin = parseFloat(brokerMargin || 0).toFixed(2);
    startDate = `${startDate.split('-')[1]}-${startDate.split('-')[2]}-${startDate.split('-')[0]}`;

    this.termForm = this.form.group({
      terms: [termsLabel, [Validators.required, this.termsValidator.bind(this)]],
      startDate: [new Date(startDate), Validators.required],
      margin: [brokerMargin, Validators.required],
      userComment: [' ', Validators.required]
    })
    this.quoteData = this.data;
    // this.termForm.valueChanges.subscribe(val => {
    //
    // })
  }
  submitTermDetails(){
    let {startDate, terms, margin, userComment} = this.termForm.value;
    let dateObj = new Date(startDate);
    startDate = dateObj.toISOString();
    let body = {
      id: null,
      oldTerms: this.data.termsLabel,
      oldStartDate: new Date(this.data.startDate).toISOString(),
      oldBrokerMargin: this.data.brokerMargin.toFixed(2),
      newStartDate: startDate,
      newTerms: terms,
      newBrokerMargin: margin ? parseFloat(margin).toFixed(2): null,
      note: userComment,
      quoteNumber: this.data.quoteNumber
    }
    // console.log(body.newDetails);
    this.quoteService.saveChangeRequest(body).subscribe(
      data => {
        this.onClose.emit();
        this.snackBar.open('Request Submitted Successfully', 'close', {
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
          panelClass: ['success-box']
        })
      },
      (err: HttpErrorResponse) =>{
        this.snackBar.open(err.message || 'Failed to submit the request', 'close', {
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
          panelClass: ['error-box']
        })
      });
  }
  closeActiveTermsDialog(e: Event){
    this.onClose.emit();
    e.stopImmediatePropagation();
  }

  get termVal() {
    return this.termForm.get('terms');
  }

  termsValidator(control: AbstractControl){
    let pattern = /^[0-9,]+$/;
    let {market} = this.data;
    if(!pattern.test(control.value)){
      return {patternInValid: true}
    }
    if(control.value.split(',').length > 7){
      return {lengthInValid: true}
    }
    if(market) {
      let termsArray = control.value.split(',');
      termsArray = termsArray.filter(item => item != undefined);
      termsArray = termsArray.map(item => parseInt(item));
      termsArray = termsArray.sort();
      // let count = termsArray.reduce((total, item) => {
      //   return total + parseInt(item);
      // }, 0)
      if(market === 'PJM' && termsArray[termsArray.length - 1] > 62){
        return {termPjmInvalid: true}
      }
      if(market === 'ERCOT' && termsArray[termsArray.length - 1] > 50){
        return {termErcotInvalid: true}
      }
    }
    return null;
  }
}
